module.exports = __webpack_public_path__ + "static/media/Le_Xuan_An.ff3e1f10.jpg";